/* istanbul ignore file */
import type { CSSProperties } from 'react';
import { maxBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { responsiveText } = theme;

import type { CopyBlockAlignment } from './types';

export interface CopyBlockCSS extends CSSProperties {
  '--textAlignment': CopyBlockAlignment;
}

export const copyContainer = css`
  text-align: var(--textAlignment);

  h2 {
    ${responsiveText.HEADING.SM};
  }

  h3 {
    ${responsiveText.HEADING.XS};
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  th,
  th > p {
    ${responsiveText.HEADING.XS};
  }

  td,
  th {
    border: 1px solid var(--neutral-black-10);
    padding: 5px;

    ${mediaQuery(
      { max: maxBreakpoints.M },
      css`
        display: block;
      `,
    )};
  }

  tr td:first-child,
  tr td:first-child > p {
    ${mediaQuery(
      { max: maxBreakpoints.M },
      css`
        ${responsiveText.HEADING.XS};
      `,
    )};
  }
`;
